module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAyOSAyOSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0iI2ZmZiIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIj48cGF0aCBkPSJNMiAyNi43NUwyNi43NSAyTTI2Ljc1IDI2Ljc1TDIgMiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/components/Drawer/whiteCross.svg
// module id = 410
// module chunks = 0